module.exports = "/_next/static/images/download-qr-3ddd10a2.png";